'use client';
var classes = {"root":"m_e2125a27","closeButton":"m_5abab665"};

export { classes as default };
//# sourceMappingURL=Dialog.module.css.mjs.map
